import store from '@store';

const setReturnUrl = () => {
	let currentUrl = window.location.href
	if(currentUrl.includes("location=")){
		store.commit('general/updateReturnUrl', decodeURIComponent(decodeURIComponent(currentUrl.split('location=')[1])));
	}
}

setReturnUrl()